import React from 'react';

const SocialAccountIcon = ({href, img, alt}) => {

  return (
    <>
      <a href={href} target='_blank'>
        <img
          src={img}
          alt={alt}
          style={{
            width: '62px',
            height: '62px',
            padding: '5px'
          }}
        />
      </a>
    </>
  )
}

export default SocialAccountIcon;